import { IWhiteboardState, IWhiteboardRenderer, IWhiteboardRenderOptions, WhiteboardRenderer, MinimapRenderer } from "..";

export class MultiWhiteboardRenderer implements IWhiteboardRenderer {
  private whiteboardRenderer: WhiteboardRenderer;
  private minimapRenderer: MinimapRenderer;

  set setWhiteboardRenderer(whiteboardRenderer: WhiteboardRenderer) {
    this.whiteboardRenderer = whiteboardRenderer;
  }

  set setMinimapRenderer(minimapRenderer: MinimapRenderer) {
    this.minimapRenderer = minimapRenderer;
  }

  render(state: IWhiteboardState, options?: IWhiteboardRenderOptions): void {
    this.whiteboardRenderer.render(state, options);

    if (this.minimapRenderer) {
      this.renderMinimap(state);
    }
  }

  renderSingleShape(state: IWhiteboardState, shapeId: string, options: IWhiteboardRenderOptions = {}): void {
    this.whiteboardRenderer.renderSingleShape(state, shapeId, options);
  }

  renderMinimap(state: IWhiteboardState): void {
    this.setMinAndMaxPositionsInMinimap();
    this.setViewportSizeAndPositionInMinimap();
    this.minimapRenderer.render(state);
  }

  private setMinAndMaxPositionsInMinimap(): void {
    const minAndMaxPositions = this.whiteboardRenderer.minAndMaxPositions;
    const rendererScale = this.whiteboardRenderer.getScale();

    // Minimap should always display the real size and position of shapes and shouldn't care what is the zoom ratio of the real canvas/stage
    this.minimapRenderer.rendererMinAndMaxPositions = {
      topLeftPos: {
        x: minAndMaxPositions.topLeftPos.x / rendererScale.x,
        y: minAndMaxPositions.topLeftPos.y / rendererScale.y,
      },
      bottomRightPos: {
        x: minAndMaxPositions.bottomRightPos.x / rendererScale.x,
        y: minAndMaxPositions.bottomRightPos.y / rendererScale.y,
      },
    };
  }

  private setViewportSizeAndPositionInMinimap(): void {
    const viewportPosition = this.whiteboardRenderer.viewportPosition;
    const viewportSize = this.whiteboardRenderer.viewportSize;
    const rendererScale = this.whiteboardRenderer.getScale();

    this.minimapRenderer.rendererViewportSizeAndPosition = {
      ...viewportPosition,
      width: viewportSize.width / rendererScale.x,
      height: viewportSize.height / rendererScale.y,
    };
  }
}
